export const RDX_DEMO_DATA_FETCH = 'rdx/demo/data/fetch';
export const RDX_DEMO_DATA_FETCH_DONE = 'rdx/demo/data/fetch/done';
export const RDX_DEMO_DATA_FETCH_ERR = 'rdx/demo/data/fetch/error';
export const RDX_DEMO_DATA_SAVE = 'rdx/demo/data/save';
export const RDX_DEMO_DATA_SAVE_DONE = 'rdx/demo/data/save/done';
export const RDX_DEMO_DATA_SAVE_ERR = 'rdx/demo/data/save/error';

export const getDemoData = (request) => {
  console.log('demoAction.getDemoData', request);
  return {
    type: RDX_DEMO_DATA_FETCH,
    data: request,
  };
};
export const getDemoDataDone = (data) => {
  console.log('getDemoDataDone.RDX_DEMO_DATA_FETCH_DONE', data);
  return {
    type: RDX_DEMO_DATA_FETCH_DONE,
    data: data,
  };
};

export const saveDemoData = (data) => {
  return {
    type: RDX_DEMO_DATA_SAVE,
    data: data,
  };
};

export const saveDemoDataDone = () => {
  return {
    type: RDX_DEMO_DATA_SAVE_DONE,
  };
};
